import { useMutation } from "@tanstack/react-query";
import {
	type CreateReminderRequestDTO,
	postClientIdentificationDocumentsIdRemindersV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type CreateIdentificationDocumentReminderVariables = {
	id: number;
	data: CreateReminderRequestDTO;
};

export const useCreateIdentificationDocumentReminderMutation = () =>
	useMutation({
		mutationFn: processResponse(
			({ id, data }: CreateIdentificationDocumentReminderVariables) =>
				postClientIdentificationDocumentsIdRemindersV2(data, id),
		),
	});
